// Primitifs visuels portés du design « Cockpit » (Liquid Glass × Apple Messages).
// Adaptés en TypeScript et câblés sur les types agency-os. Voir cockpit.css.
import { useState, type ReactNode } from "react";
import { messaging } from "./api";

// — Logos officiels (tracés Simple Icons, viewBox 24×24) —
type Net = { label: string; color: string; icon: string | null };
export const NETWORKS: Record<string, Net> = {
  whatsapp: {
    label: "WhatsApp",
    color: "#25D366",
    icon: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z",
  },
  linkedin: {
    label: "LinkedIn",
    color: "#0A66C2",
    icon: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z",
  },
  googlechat: {
    label: "Google Chat",
    color: "#34A853",
    icon: "M1.637 0C.733 0 0 .733 0 1.637v16.5c0 .904.733 1.636 1.637 1.636h3.955v3.323c0 .804.97 1.207 1.539.638l3.963-3.96h11.27c.903 0 1.636-.733 1.636-1.637V5.592L18.408 0Zm3.955 5.592h12.816v8.59H8.455l-2.863 2.863Z",
  },
  slack: {
    label: "Slack",
    color: "#E01E5A",
    icon: "M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zm10.122 2.521a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zm-1.268 0a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zm-2.523 10.122a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zm0-1.268a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z",
  },
  telegram: {
    label: "Telegram",
    color: "#2AABEE",
    icon: "M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z",
  },
  gmail: {
    label: "Gmail",
    color: "#EA4335",
    icon: "M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z",
  },
  hermes: {
    label: "Hermes",
    color: "#8B5CF6",
    icon: "M13 2 3 14h7l-1 8 11-14h-7l1-6z",
  },
  system: {
    label: "Agency OS",
    color: "#d7a04c",
    icon: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm4.5-12.5-3.18 6.32L7 16.5l3.18-6.32L16.5 7.5z",
  },
};

export const netKey = (network = ""): string | undefined =>
  Object.keys(NETWORKS).find((k) => network.toLowerCase().includes(k));

/**
 * Réseaux de type « e-mail » — structure et usage distincts du chat (objet, To/Cc,
 * corps long/HTML, pièces jointes de premier ordre, asynchrone). On les sépare
 * dans une vue dédiée. Liste extensible (un futur Outlook s'ajoute ici).
 */
export const EMAIL_NETWORKS = ["gmail"] as const;

/** Vrai si le réseau de la conversation relève du « monde » e-mail. */
export const isEmailNetwork = (network = ""): boolean => {
  const k = netKey(network);
  return k != null && (EMAIL_NETWORKS as readonly string[]).includes(k);
};

export const netInfo = (network = ""): Net =>
  NETWORKS[netKey(network) ?? ""] ?? { label: network || "Autre", color: "#8b8b94", icon: null };

export function NetIcon({
  network,
  size = 14,
  color,
}: {
  network: string;
  size?: number;
  color?: string;
}) {
  const n = netInfo(network);
  if (!n.icon) return <span className="dot" style={{ background: n.color }} />;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color ?? n.color} aria-hidden="true">
      <path d={n.icon} />
    </svg>
  );
}

export const ComposeIcon = ({ size = 16 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-6" />
    <path d="M18.4 2.6a2.1 2.1 0 0 1 3 3L13 14l-4 1 1-4Z" />
  </svg>
);

// — Icônes au trait (style SF Symbols) —
const IC: Record<string, ReactNode> = {
  inbox: (
    <>
      <path d="M22 12h-6l-2 3h-4l-2-3H2" />
      <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
    </>
  ),
  unread: (
    <>
      <path d="M20 10.8a7.6 7.6 0 0 1-8.2 7.6 8 8 0 0 1-3.3-.8L4 19l1.3-4.2A7.6 7.6 0 0 1 4.6 11 7.6 7.6 0 0 1 12 3.3h.5a7.6 7.6 0 0 1 7.5 7v.5z" />
      <circle cx="18.5" cy="5.5" r="3" fill="currentColor" stroke="none" />
    </>
  ),
  archive: (
    <>
      <rect x="2" y="4" width="20" height="5" rx="1.5" />
      <path d="M4 9v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9" />
      <path d="M10 13h4" />
    </>
  ),
  gear: (
    <>
      <circle cx="12" cy="12" r="3.2" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.01a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h.01a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.01a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </>
  ),
  chevron: <path d="m15 19-7-7 7-7" />,
  chevrons: (
    <>
      <path d="m7 15 5 5 5-5" />
      <path d="m7 9 5-5 5 5" />
    </>
  ),
  pin: (
    <>
      <path d="M12 17v5" />
      <path d="M9 3h6l-.8 6.2 2.8 2.3V14H7v-2.5l2.8-2.3L9 3z" />
    </>
  ),
  bell: (
    <>
      <path d="M6 8.5a6 6 0 0 1 12 0c0 6.5 2.5 8 2.5 8h-17s2.5-1.5 2.5-8" />
      <path d="M10.4 20.5a1.8 1.8 0 0 0 3.2 0" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  attach: (
    <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  ),
  refresh: (
    <>
      <path d="M21 12a9 9 0 1 1-2.64-6.36" />
      <path d="M21 3v6h-6" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </>
  ),
  spark: <path d="M12 3l1.6 5.4L19 10l-5.4 1.6L12 17l-1.6-5.4L5 10l5.4-1.6z" />,
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />,
  tag: (
    <>
      <path d="M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9z" />
      <circle cx="7.5" cy="7.5" r="1.3" fill="currentColor" stroke="none" />
    </>
  ),
  logout: (
    <>
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
      <path d="m16 17 5-5-5-5" />
      <path d="M21 12H9" />
    </>
  ),
};

export const Ic = ({ name, size = 15 }: { name: string; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {IC[name]}
  </svg>
);

// — Avatar : initiales (teinte stable dérivée du titre) + badge réseau —
export const hueOf = (s = ""): number => {
  let h = 0;
  for (const c of s) h = (h * 31 + (c.codePointAt(0) ?? 0)) % 360;
  return h;
};

// Couleur stable par expéditeur (noms colorés façon Apple Messages / Beeper).
// Les 8 teintes vivent dans css/tokens.css (--sender-1…8, variantes
// sombre/clair) : on renvoie la variable, jamais une valeur en dur.
export const senderColor = (s = ""): string => `var(--sender-${(hueOf(s) % 8) + 1})`;

export const initialsOf = (title = ""): string => {
  const words = title
    .trim()
    .split(/\s+/)
    .filter((w) => /[\p{L}\p{N}]/u.test(w));
  const a = words[0]?.match(/[\p{L}\p{N}]/u)?.[0] ?? "?";
  const b = words[1]?.match(/[\p{L}\p{N}]/u)?.[0] ?? "";
  return (a + b).toUpperCase();
};

export function Avatar({
  chat,
  size = 44,
  name,
}: {
  chat: { network: string; title: string; id: string };
  size?: number;
  name?: string;
}) {
  const n = netInfo(chat.network);
  const label = name || chat.title;
  const hue = hueOf(label || chat.id);
  // Retry the photo when the avatar is reused for a different conversation
  // (header / info panel switch chats without remounting) : on mémorise l'id
  // cassé au lieu d'un booléen remis à zéro par effet — pure dérivation.
  const [brokenId, setBrokenId] = useState<string | null>(null);
  const broken = brokenId === chat.id;
  return (
    <div
      className="avatar"
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.36),
        background: `linear-gradient(135deg, hsl(${hue} 42% 40%), hsl(${hue} 48% 27%))`,
      }}
    >
      {initialsOf(label)}
      {/* Real contact/group photo (cookie-auth). Falls back to the initials
          underneath on 404/501 (connector has no avatar) via onError. */}
      {!broken && chat.id && (
        <img
          className="avatar-img"
          src={messaging.conversationAvatarUrl(chat.id)}
          alt=""
          loading="lazy"
          onError={() => setBrokenId(chat.id)}
        />
      )}
      <span
        className="avatar-badge"
        style={{
          background: n.color,
          width: Math.round(size * 0.42),
          height: Math.round(size * 0.42),
        }}
      >
        <NetIcon network={chat.network} size={Math.round(size * 0.25)} color="#fff" />
      </span>
    </div>
  );
}

// — Rendu riche : **gras**, *italique*, ~~barré~~, [liens](url) + URLs nues —
const URL_RE = /(https?:\/\/[^\s]+)/g;
const MD_RE =
  /(\*\*[^*\n]+\*\*|\*[^*\n]+\*|__[^_\n]+__|~~[^~\n]+~~|\[[^\]\n]+\]\(https?:\/\/[^)\s]+\)|https?:\/\/[^\s]+)/g;

export function RichText({ text, md = false }: { text: string; md?: boolean }) {
  const out: ReactNode[] = [];
  String(text ?? "")
    .split(md ? MD_RE : URL_RE)
    .forEach((p, i) => {
      if (!p) return;
      let m: RegExpMatchArray | null;
      if (md && (m = p.match(/^\*\*([^*\n]+)\*\*$/))) out.push(<strong key={i}>{m[1]}</strong>);
      else if (md && (m = p.match(/^\*([^*\n]+)\*$/))) out.push(<em key={i}>{m[1]}</em>);
      else if (md && (m = p.match(/^__([^_\n]+)__$/))) out.push(<u key={i}>{m[1]}</u>);
      else if (md && (m = p.match(/^~~([^~\n]+)~~$/))) out.push(<s key={i}>{m[1]}</s>);
      else if (md && (m = p.match(/^\[([^\]\n]+)\]\((https?:\/\/[^)\s]+)\)$/)))
        out.push(
          <a key={i} href={m[2]} target="_blank" rel="noreferrer">
            {m[1]}
          </a>,
        );
      else if (/^https?:\/\//.test(p))
        out.push(
          <a key={i} href={p} target="_blank" rel="noreferrer">
            {p}
          </a>,
        );
      else out.push(p);
    });
  return <>{out}</>;
}

// — Dates —
export const fmtTime = (iso: string | null): string => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date().toDateString() === d.toDateString();
  return today
    ? d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("fr-FR", { day: "numeric", month: "short" });
};

export const fmtClock = (iso: string | null): string =>
  iso ? new Date(iso).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "";

export const dayKey = (iso: string | null): string => (iso ? new Date(iso).toDateString() : "");

export const fmtDay = (iso: string | null): string => {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  if (now.toDateString() === d.toDateString()) return "Aujourd'hui";
  if (new Date(now.getTime() - 864e5).toDateString() === d.toDateString()) return "Hier";
  return d.toLocaleDateString("fr-FR", {
    weekday: "long",
    day: "numeric",
    month: "long",
    ...(d.getFullYear() !== now.getFullYear() ? { year: "numeric" as const } : {}),
  });
};

const stripMd = (s = ""): string =>
  s
    .replace(/\[([^\]\n]+)\]\(https?:\/\/[^)\s]+\)/g, "$1")
    .replace(/\*\*([^*\n]+)\*\*/g, "$1")
    .replace(/\*([^*\n]+)\*/g, "$1")
    .replace(/__([^_\n]+)__/g, "$1")
    .replace(/~~([^~\n]+)~~/g, "$1");

// Aperçu du dernier message (liste). Notre backend renvoie lastMessageBody (#Beeper).
export const previewOf = (c: {
  network: string;
  lastMessageBody?: string | null;
  lastMessageHasMedia?: boolean;
}): string => {
  const txt = stripMd((c.lastMessageBody ?? "").replace(/\s+/g, " ").trim());
  if (txt) return txt;
  // Dernier message média sans texte → libellé au lieu d'un blanc.
  if (c.lastMessageHasMedia) return "Pièce jointe";
  // Pas de dernier message connu → rien (surtout pas le nom du réseau).
  return "";
};
